import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "w-full relative font-montserrat" }
const _hoisted_2 = {
  key: 0,
  class: "bg-red-600 border border-red-600 my-[10px] text-white text-center fixed md:top-[80px] top-[60px] shadow-lg left-[50%] translate-x-[-50%] font-bold flex justify-center items-center z-30 rounded-[5px] max-w-[450px] w-[90%] p-[20px]"
}
const _hoisted_3 = { class: "relative pt-[70px] w-full mb-[50px]" }
const _hoisted_4 = { class: "flex justify-end items-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = {
  key: 0,
  class: "fas fa-spinner fa-spin"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "w-full relative py-[10px] flex justify-center items-center" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Please upload the Excel file containing the emails of users to add as subscribers.", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "w-full py-[20px] flex justify-center items-center" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "text-center font-bold text-sm" }, "© 2023 Cotonou Cadjehoun, Tous droits réservés.")
], -1)

import headerComponent from '@/components/headerComponentAdmin.vue';
import { ref, onMounted } from 'vue';
import axios from 'axios';
import { useRouter } from 'vue-router';
import axiosInstance from '@/plugins/axios';



export default /*#__PURE__*/_defineComponent({
  __name: 'ImportSubscribers',
  setup(__props) {

const loading = ref(false);
const loading1 = ref(false);
const loading2 = ref(false);
const router = useRouter();
const pageTitle = ref('Import subscribers');

const content = ref('');
const object = ref('');
const selectedFile = ref(null);
const errorMessage = ref("");

const isNewRoute = router.currentRoute.value.path === "/ImportSubscribers";

onMounted(() => {
    document.title = pageTitle.value;
});

const handleFileChange = (event: any) => {
  selectedFile.value = event.target.files[0];
};

let userId = ref(null);

const saveSubscribers = async () => {
  try {
    loading1.value = true;
    const token = localStorage.getItem('token');
    if (!token) return;


    const userResponse = await axiosInstance.get('/auth/users/me/', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    userId.value = userResponse.data.id;

    const formData = new FormData();

    if (selectedFile.value) {
      formData.append('stylesheet', selectedFile.value);
    };

    const response = await axiosInstance.post('/subscribers/import/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${token}`,
      },
    });

    router.push('/dashboard');
  } catch (error) {
    if(error.response && error.response.status && error.response.status == 400) {
        if(error.response.data && error.response.data.stylesheet) {
          errorMessage.value = "uploaded file: " + error.response.data.stylesheet[0]
        } else {
          errorMessage.value = "Unknow error";
        }
    } else {
      errorMessage.value = 'Erreur lors de l\'importattion ou du sauvegarde des subscribers';
    }
    
    hideErrorMessageAfterDelay();
  } finally {
    loading1.value = false;
  }
};

const hideErrorMessageAfterDelay = () => {
  setTimeout(() => {
    errorMessage.value = ''; 
  }, 5000);
};

onMounted(() => {
  document.title = pageTitle.value;
});




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(headerComponent),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        isNewRoute
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("button", {
                disabled: loading1.value,
                class: "text-sm font-bold rounded-[5px] min-w-[60px] p-[10px] border border-gray-400 m-[10px] bg-cyan-800 text-white shadow-lg",
                onClick: saveSubscribers
              }, [
                (loading1.value)
                  ? (_openBlock(), _createElementBlock("i", _hoisted_7))
                  : (_openBlock(), _createElementBlock("span", _hoisted_8, "Import Subscribers"))
              ], 8, _hoisted_6)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("input", {
          type: "file",
          onChange: handleFileChange,
          class: "m-[10px] max-w-[calc(100%-52%)] p-[10px]"
        }, null, 32)
      ])
    ]),
    _hoisted_11
  ]))
}
}

})